export default __webpack_public_path__ + "static/media/bridge_logo_jelly.71424459.svg";